export default {
  event_earnings: "number",
  donation_earnings: "number",
  donation_pledges: "number",
  raffle_purchase_earnings: "number",
  fixed_purchase_earnings: "number",
  bid_earnings: "number"
}



// WEBPACK FOOTER //
// ./src/store/models/stat.js